import {
  Popover,
  PopoverClose,
} from '@bambi/component-library/src/components/Popover/Popover';
import { classNames } from '@bambi/component-library/src/utils/classNames';

export interface FilterPopoverProps {
  children: React.ReactNode;
  includePrimaryAction?: boolean;
  open?: boolean;
  triggerElement: React.ReactNode;
  // Appears before the footer container, after the content
  preFooterContainerElement?: React.ReactNode;
  // Appears before the cancel button
  preFooterElement?: React.ReactNode;
  // Appears after the apply button
  postFooterElement?: React.ReactNode;
  cancelButtonText?: string;
  applyButtonText?: string;
  contentClassName?: string;
  onApply?: () => void;
  onCancel?: () => void;
  onOpenChange?: (open: boolean) => void;
}
export function FilterPopover({
  children,
  includePrimaryAction = true,
  open,
  triggerElement,
  preFooterContainerElement,
  preFooterElement,
  postFooterElement,
  cancelButtonText = 'Cancel',
  applyButtonText = 'Apply',
  contentClassName = 'flex max-h-80 w-72 flex-col justify-between px-1',
  onApply,
  onCancel,
  onOpenChange,
}: FilterPopoverProps) {
  return (
    <Popover
      open={open}
      onOpenChange={onOpenChange}
      trigger={triggerElement}
      content={
        <div className={contentClassName}>
          <div
            className="h-fit overflow-y-auto"
            data-testid="filter-popover-content"
          >
            {children}
          </div>
          {preFooterContainerElement}
          <div className="grid grid-cols-2 gap-x-2 gap-y-2 border-t border-gray-200 pt-4">
            {preFooterElement}
            <PopoverClose
              className={classNames(
                'focus:ring-indigo-500 inline-flex flex-grow items-center justify-center rounded border border-gray-100 bg-gray-100 px-3 py-2 text-sm font-medium text-gray-900 hover:bg-gray-300 focus:outline-mint disabled:cursor-not-allowed disabled:opacity-50',
                !includePrimaryAction && 'col-span-2'
              )}
              onClick={onCancel}
            >
              {cancelButtonText}
            </PopoverClose>
            {includePrimaryAction ? (
              <PopoverClose
                className="focus:ring-indigo-500 inline-flex flex-grow items-center justify-center rounded border border-mint bg-mint px-3 py-2 text-sm font-medium text-white hover:bg-mint focus:outline-mint disabled:cursor-not-allowed disabled:opacity-50"
                onClick={onApply}
              >
                {applyButtonText}
              </PopoverClose>
            ) : null}
            {postFooterElement}
          </div>
        </div>
      }
    />
  );
}
